<template>
  <Layout>
    <template #header-container v-if="!loading && !dataHeader.isActive">
      <div class="container-alert">
        <McAlert
          class="custom-alert"
          variant="info"
          :text="$t('driverScore.title.inactiveDriver')"
          withIcon
        >
          <template #suffix>
            <b-button class="button-link" @click="$router.push({ path: '/master/employee' })">
              <span>{{ $t('driverScore.title.toMasterData') }} </span>
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </b-button>
          </template>
        </McAlert>
      </div>
    </template>

    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/driverscore/" />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-skeleton-wrapper :loading="loading">
            <template #loading>
              <b-row class="mb-4">
                <b-col> <b-skeleton width="100%" height="200px" class="my-3" /> </b-col>
                <b-col> <b-skeleton width="100%" height="200px" class="my-3" /> </b-col>
                <b-col> <b-skeleton width="100%" height="200px" class="my-3" /> </b-col>
              </b-row>
            </template>

            <b-row class="mb-4">
              <b-col md="4" class="my-3">
                <div class="card h-100 border border-1">
                  <div class="card-body d-flex align-items-center justify-content-center">
                    <div class="text-center">
                      <img
                        :src="dataHeader.avatar"
                        alt
                        class="avatar-lg rounded-circle img-thumbnail"
                        style="object-fit: cover"
                      />
                      <h2 class="mt-2">{{ dataHeader.driver }}</h2>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col md="4" class="my-3">
                <div class="card h-100 border border-1">
                  <div class="card-body d-flex align-items-center justify-content-center">
                    <div class="text-center">
                      <span class="font-size-16">{{ $t('liveView.modal.tripTotal') }}</span>
                      <div class="d-flex mt-2">
                        <h1>
                          {{ dataHeader.totalDriven }}
                        </h1>
                        <span class="font-size-16 ms-1 align-self-center">{{ `Km` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col md="4" class="my-3">
                <div
                  class="card h-100 border border-1 bg-soft mc-driver-grade"
                  :class="gradeClass[dataHeader.finalGrade]"
                >
                  <div class="card-body d-flex align-items-center justify-content-center">
                    <div class="w-75">
                      <div class="font-size-16 text-center mb-3">
                        {{ $t('driverScore.title.driverScore') }}
                      </div>
                      <div class="row">
                        <div class="text-center col-md-6" :class="lineClass[dataHeader.finalGrade]">
                          <h1 class="text-wrap">{{ dataHeader.score }}</h1>
                          <span class="font-size-16 text-center">
                            {{ $t('driverScore.field.totalScore') }}
                          </span>
                        </div>
                        <div class="text-center col-md-6">
                          <h1>
                            <span
                              class="badge rounded-pill"
                              :class="gradeClass[dataHeader.finalGrade]"
                            >
                              {{ dataHeader.finalGrade == 'N' ? '-' : dataHeader.finalGrade }}
                            </span>
                          </h1>
                          <span class="font-size-16 text-center">
                            {{ $t('driverScore.field.indexScore') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-skeleton-wrapper>
          <h5 class="font-size-20">{{ $t('driverScore.object.scoreParameter') }}</h5>

          <b-skeleton-wrapper :loading="loading && score.length == 0">
            <template #loading>
              <b-row>
                <b-col
                  xs="12"
                  sm="6"
                  lg="4"
                  xl="3"
                  class="responsive-card"
                  v-for="(item, index) in skeletonCards"
                  :key="index"
                >
                  <b-skeleton width="100%" height="125px" class="my-3" />
                </b-col>
              </b-row>
            </template>
            <b-row class="mt-3 mc-driver-stats">
              <b-col
                xs="12"
                sm="6"
                lg="4"
                xl="3"
                class="responsive-card"
                v-for="(item, index) in score"
                :key="index"
              >
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="align-self-center col-md-3 col-sm-3">
                        <div class="avatar-sm">
                          <div class="avatar-title rounded-circle bg-warning font-size-24">
                            <i class="mc-fa icon-outline_alert-triangle"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-9 col-sm-9">
                        <span class="font-size-16">
                          {{ item.label }}
                        </span>
                        <h2 class="mt-2">{{ item.value }}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-skeleton-wrapper>
        </div>
      </div>
    </div>

    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <h4 class="my-4">{{ $t('driverScore.field.alertList') }}</h4>
        <b-row>
          <b-col sm="6" md="8" xl="9">
            <b-skeleton width="100%" height="50px" />
          </b-col>
          <b-col sm="6" md="4" xl="3">
            <b-skeleton width="100%" height="50px" />
          </b-col>
        </b-row>
        <b-card>
          <b-skeleton width="100%" height="300px" />
        </b-card>
      </template>
      <AlertListSection :drivername="dataHeader.driver" :lastSync="lastSync" v-if="lastSync" />
    </b-skeleton-wrapper>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import McButtonBack from '@/components/McButtonBack'
import AlertListSection from './AlertListSection-v2'
import { mapGetters } from 'vuex'
import McAlert from '@/components/McAlert'

import { GET_DRIVER_SCORE } from '@/services/api/driverscore/score'
/**
 * Starter component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AlertListSection,
    McButtonBack,
    McAlert,
  },
  mixins: [Helper, MixPanel],
  page: {
    title: 'Driver Score',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      filterDate: JSON.parse(localStorage.getItem('driverscore-filter-date')),
      isBusy: false,
      driverId: 0,
      dataHeader: {},
      score: [],
      imagePreview: require(`@/assets/images/default-image-user.png`),
      gradeClass: {
        A: 'bg-success',
        B: 'bg-success',
        C: 'bg-warning',
        D: 'bg-danger',
        E: 'bg-danger',
        N: 'bg-secondary',
      },
      lineClass: {
        A: 'line-success',
        B: 'line-success',
        C: 'line-warning',
        D: 'line-danger',
        E: 'line-danger',
        N: 'line-secondary',
      },
      lastSync: null,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    skeletonCards() {
      if (this.hasAccessAll(['vehicle_video_trackers:read'])) return 12
      else return 6
    },
    title() {
      return this.$t('driverScore.field.driverScoreDetail')
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.initHeader()
    },
  },
  async mounted() {
    this.track('View Detail Driver Score Page')
    this.driverId = Number(this.$route.params.driverId)
    const hasData = await this.getData()
    if (hasData) this.initHeader()
  },
  methods: {
    async getData() {
      this.loading = true

      const res = await this.$apollo.query({
        query: GET_DRIVER_SCORE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            driverId: this.driverId,
            month: this.filterDate.month,
            year: this.filterDate.year,
          },
        },
      })

      const driverScore = res.data?.driverScore?.driverScore
      if (!driverScore) {
        this.loading = false
        this.$mcToast.info({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                tag: 'h6',
                text: this.$t('global.emptyTable'),
              },
            ],
          },
        })
        this.$router.back()
        return false
      }

      this.lastSync = driverScore.lastSync

      this.dataHeader = {
        avatar: driverScore.driver.photograph ? driverScore.driver.photograph : this.imagePreview,
        driver: driverScore.driver.fullname,
        isActive: driverScore.driver.isActive,
        totalDriven: this.localeThousandFormat(this.minimizeFloat(driverScore.totalDriven)),
        finalGrade: driverScore.finalGrade ? driverScore.finalGrade : 'N',
        score:
          driverScore.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.score))
            : '-',
        harshAccels:
          driverScore.harshAccel.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.harshAccel.score))
            : '-',
        harshBrakes:
          driverScore.harshBrake.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.harshBrake.score))
            : '-',
        overspeeds:
          driverScore.overspeed.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.overspeed.score))
            : '-',
        sharpTurns:
          driverScore.sharpturn.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.sharpturn.score))
            : '-',
        smoking:
          driverScore.smoking.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.smoking.score))
            : '-',
        yawn:
          driverScore.yawn.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.yawn.score))
            : '-',
        sleep:
          driverScore.eyeClosed.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.eyeClosed.score))
            : '-',
        calling:
          driverScore.phoneCalling.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.phoneCalling.score))
            : '-',
        disturb:
          driverScore.distraction.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.distraction.score))
            : '-',
        outframe:
          driverScore.missingFace.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.missingFace.score))
            : '-',
        idle:
          driverScore.exceededIdleTime.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.exceededIdleTime.score))
            : '-',
        parking:
          driverScore.exceededParkingTime.score !== null
            ? this.localeThousandFormat(this.minimizeFloat(driverScore.exceededParkingTime.score))
            : '-',
      }

      this.loading = false
      return true
    },
    initHeader() {
      this.score = [
        {
          label: this.$t('driverScore.object.harshAccelScore'),
          value: this.dataHeader.harshAccels,
        },
        {
          label: this.$t('driverScore.object.harshBrakeScore'),
          value: this.dataHeader.harshBrakes,
        },
        {
          label: this.$t('driverScore.object.overspeedScore'),
          value: this.dataHeader.overspeeds,
        },
        {
          label: this.$t('driverScore.object.sharpTurnScore'),
          value: this.dataHeader.sharpTurns,
        },
        {
          label: this.$t('driverScore.object.idleScore'),
          value: this.dataHeader.idle,
        },
        {
          label: this.$t('driverScore.object.parkingScore'),
          value: this.dataHeader.parking,
        },
      ]
      const dms = [
        {
          label: this.$t('driverScore.object.smokingScore'),
          value: this.dataHeader.smoking,
        },
        {
          label: this.$t('driverScore.object.yawnScore'),
          value: this.dataHeader.yawn,
        },
        {
          label: this.$t('driverScore.object.asleepScore'),
          value: this.dataHeader.sleep,
        },
        {
          label: this.$t('driverScore.object.callingScore'),
          value: this.dataHeader.calling,
        },
        {
          label: this.$t('driverScore.object.disturbScore'),
          value: this.dataHeader.disturb,
        },
        {
          label: this.$t('driverScore.object.outframeScore'),
          value: this.dataHeader.outframe,
        },
      ]
      if (this.hasAccessAll(['vehicle_video_trackers:read'])) {
        this.score.push(...dms)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-modal__filter-item .multiselect {
  width: 100%;
}
.mc-driver-stats {
  .card {
    height: 137px;
    border: 1px solid $teal-100;
  }

  .col-sm-12:first-child,
  .col-sm-12:nth-child(2),
  .col-sm-12:nth-child(4) {
    .card-body {
      padding-top: 32px;
    }
  }

  .avatar-sm {
    height: 3rem;
    width: 3rem;
    margin: 0 auto;
  }
  .mc-fa {
    &:before {
      color: $white;
    }
  }
}
.line-success {
  border-right: 2px solid $success;
  height: 100%;
}
.line-warning {
  border-right: 2px solid $warning;
  height: 100%;
}
.line-danger {
  border-right: 2px solid $danger;
  height: 100%;
}

@media only screen and (max-width: 1400px) {
  .mc-driver-stats {
    .col-xl-3 {
      .col-md-3.align-self-center {
        align-self: flex-start !important;
      }
    }
  }
}

@media only screen and (max-width: 1300px) {
  .mc-driver-stats {
    .col-xl-3 {
      width: 33.3333%;
    }
  }
}

@media only screen and (max-width: 1080px) {
  .mc-driver-stats {
    .responsive-card {
      .card {
        height: auto;
      }
      .col-md-3 {
        width: 100%;
        padding: 0;
      }
      .col-md-9 {
        text-align: center;
        margin-top: 10px;
        width: 100%;
        padding: 0;
      }
    }
  }
  .mc-driver-grade {
    .col-md-6 {
      width: 100%;
    }
    .line-success {
      border-right: 0;
      border-bottom: 2px solid $success;
      padding: 10px;
      margin-bottom: 5px;
    }
    .line-warning {
      border-right: 0;
      border-bottom: 2px solid $warning;
      padding: 10px;
      margin-bottom: 10px;
    }
    .line-danger {
      border-right: 0;
      border-bottom: 2px solid $danger;
      padding: 10px;
      margin-bottom: 5px;
    }
  }
}

@media only screen and (max-width: 600px) {
  .mc-driver-stats {
    .card {
      height: auto;
    }
    .col-md-3 {
      padding: 0;
    }
    .col-md-9 {
      text-align: center;
      margin-top: 10px;
      padding: 0;
    }

    .col-xl-3 {
      width: 100%;
    }
  }
  .line-success {
    border-right: 0;
    border-bottom: 2px solid $success;
    padding: 10px;
    margin-bottom: 5px;
  }
  .line-warning {
    border-right: 0;
    border-bottom: 2px solid $warning;
    padding: 10px;
    margin-bottom: 10px;
  }
  .line-danger {
    border-right: 0;
    border-bottom: 2px solid $danger;
    padding: 10px;
    margin-bottom: 5px;
  }
}

.container-alert {
  margin-top: -25px;
  margin-bottom: 20px;
  .custom-alert {
    display: flex;
    align-items: center;
    border: 0 !important;
    border-radius: 0;

    .mc-alert {
      padding: 100px !important;
    }

    .mc-alert.mc-alert__warning.d-flex {
      gap: 0 !important;
      padding-left: 16px !important;
    }
  }
}

.button-link {
  display: flex;
  border-color: transparent;
  background-color: transparent;
  white-space: nowrap;
  align-items: center;
  justify-content: space-between;

  .bx-right-arrow-circle:before {
    color: $mep-primary;
    margin-left: 8px;
  }

  &:hover {
    background-color: transparent;

    .bx-right-arrow-circle:before {
      background-color: transparent;
    }
  }

  &:disabled {
    color: $mep-color-text-200;
    background-color: transparent;

    .bx-right-arrow-circle:before {
      color: $mep-color-text-200;
    }
  }

  &:focus {
    background-color: transparent;

    .bx-right-arrow-circle:before {
      background-color: transparent;
    }
  }
}
</style>
